import { render, staticRenderFns } from "./SalaryTypeFilter.vue?vue&type=template&id=40079912&"
import script from "./SalaryTypeFilter.vue?vue&type=script&lang=js&"
export * from "./SalaryTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports